<template>
  <div class="w-full">
    <div class="flex justify-center py-[20px] sm:px-6 px-4">
      <div class="w-full">
        <div class="rounded shadow p-6 relative bg-white dark:bg-[#111213]">
          <div class="items-start sm:flex">
            <div>
              <div
                class="flex items-center justify-center w-20 h-20 p-2 border-2 rounded-full dark:bg-white"
              >
                <img :src="logo" alt="" />
              </div>
            </div>

            <div class="ml-4">
              <!--                            <div class="absolute right-0 flex items-center justify-center px-4 py-2 bg-green-100 sm:top-8 top-12 rounded-tl-3xl rounded-bl-3xl">
                                                            <p class="text-xs font-semibold text-center text-green-700">SPONSORED</p>
                                                        </div>-->
              <div class="pt-4 sm:pt-0">
                <p
                  class="pt-1 text-xl font-semibold leading-5 text-gray-800 dark:text-gray-100"
                >
                  {{ item.name }}
                </p>
                <p
                  class="inline-flex items-center space-x-[2px] text-sm leading-4 pt-2 text-gray-500 dark:text-gray-400"
                >
                  <span
                    ><svg
                      class="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clip-rule="evenodd"
                      ></path></svg
                  ></span>
                  <span class="font-semibold text-indigo-700 dark:text-white">{{
                    item.city
                  }}</span
                  >, {{ item.region }}
                </p>
              </div>

              <div class="mt-2">
                <p
                  v-if="item.info"
                  class="py-2 text-sm text-gray-500 dark:text-gray-400"
                >
                  {{ item.info }}
                </p>
                <div class="items-start mt-4 space-x-4 sm:flex">
                  <div v-if="item.phone" class="flex items-center">
                    <svg
                      class="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                      ></path>
                    </svg>
                    <p
                      class="ml-2 text-sm leading-4 text-gray-500 dark:text-gray-400"
                    >
                      {{ item.phone }}
                    </p>
                  </div>
                  <div v-if="item.email" class="flex items-center mt-4 sm:mt-0">
                    <svg
                      class="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <p
                      class="ml-2 text-sm leading-4 text-gray-500 dark:text-gray-400"
                    >
                      {{ item.email }}
                    </p>
                  </div>
                  <div v-if="item.link" class="flex items-center mt-4 sm:mt-0">
                    <p
                      class="inline-flex ml-2 space-x-2 text-sm leading-4 text-gray-500 dark:text-gray-400"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                        ></path>
                        <path
                          d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                        ></path>
                      </svg>
                      <a target="_blank" :title="item.name" :href="item.link">
                        {{ t("partner.link") }}</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { computed } from "vue";

export default {
  name: "Partner",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const defaultLogo =
      "https://d63o8ljxxv9zy.cloudfront.net/719f281e-1547-4943-9f89-40d792120270/img/logo-light.svg";
    const logo = computed(() =>
      props.item.logo ? props.item.logo : defaultLogo
    );
    return {
      t,
      logo,
    };
  },
};
</script>
